export function parseTime(
  s: string
): undefined | { hours: number; minutes: number } {
  if (s === null || s === undefined || s === '') return;
  if (isNaN(Number(s.charAt(0)))) return;

  s = trimRightAfterSecondColon(s);

  const numbers = s.replace(/\D/g, '');

  let hours = null,
    minutes = null;
  if (numbers.length <= 2) {
    ({ hours, minutes } = parseTwoOrFewerDigits(s, numbers));
  } else if (numbers.length === 3) {
    hours = parseTwoOrFewerDigits(s, firstDigit(numbers)).hours;
    minutes = Number(numbers.slice(1, 3));
  } else if (numbers.length > 3) {
    hours = parseTwoOrFewerDigits(s, firstTwoDigits(numbers)).hours;
    minutes = Number(numbers.slice(2, 4));
  }

  if (hours == null || minutes == null) return;

  return { hours, minutes };
}

function parseTwoOrFewerDigits(s: string, numbers: string) {
  let hours = null,
    minutes = null;
  const nums = Number(numbers);
  if (nums <= 24) {
    hours = nums;

    if (contains_p(s) && nums < 12) {
      hours = nums + 12;
    }

    if (contains_a(s) && nums == 12) {
      hours = 0;
    }

    if (nums == 24) {
      hours = 0; // for compatibility with Javascript Date
    }

    minutes = 0;
  } else {
    return { hours: null, minutes: null };
  }
  return { hours, minutes };
}

function contains_p(s: string) {
  return s.toLowerCase().includes('p');
}

function contains_a(s: string) {
  return s.toLowerCase().includes('a');
}

function firstDigit(s: string) {
  return s.slice(0, 1);
}

function firstTwoDigits(s: string) {
  return s.slice(0, 2);
}

function trimRightAfterSecondColon(s: string) {
  const arr = s.split(':');
  if (arr.length >= 3) return arr.slice(0, 2).join(':');
  else return arr.join(':');
}
